module.exports = __webpack_public_path__ + "img/antes_despues_242.e572dfc8.png";